module.exports = __webpack_public_path__ + "static/media/deleteIcon.e4d782c5.svg";